import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import {} from 'react';
export function EmptyState({ title, description, action }) {
    return (_jsxs("div", { className: "flex flex-col items-center justify-center py-16 gap-3 text-center", children: [_jsx("p", { className: "text-[20px] font-semibold text-on-surface", children: title }), _jsx("p", { className: "text-[15px] font-normal text-on-surface-variant max-w-xs", children: description }), action && _jsx("div", { className: "mt-1", children: action })] }));
}
